import Icon from "@ant-design/icons";

const SVG = () => (
  <svg width="1em" height="1em" viewBox="0 0 14 14" fill="currentColor">
    <title></title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.50411 4.83748C2.73191 4.60967 3.10126 4.60967 3.32906 4.83748L6.99992 8.50834L10.6708 4.83748C10.8986 4.60967 11.2679 4.60967 11.4957 4.83748C11.7235 5.06529 11.7235 5.43463 11.4957 5.66244L7.4124 9.74577C7.18459 9.97358 6.81525 9.97358 6.58744 9.74577L2.50411 5.66244C2.2763 5.43463 2.2763 5.06529 2.50411 4.83748Z"
    />
  </svg>
);

const ChevronDownIcon = (props) => <Icon component={SVG} {...props} />;

export default ChevronDownIcon;
